module.exports = __webpack_public_path__ + "img/betraillogo.560a2c3c.png";